var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldRender)?_c('div',{class:{'field-disabled': _vm.isDisabled && !_vm.hideIfNoAccess}},[_vm._t("default",null,{"disabled":_vm.isDisabled,"hidden":!_vm.shouldRender})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }